import { z } from 'zod';
export const DEFAULT_PAGE_SIZE = 20;
/** Limite de segurança: nenhuma rota devolve mais itens que isto por página. */
export const MAX_PAGE_SIZE = 100;
/** Parâmetros de paginação aceitos na query string de rotas de listagem. */
export const pageQuerySchema = z.strictObject({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce
        .number()
        .int()
        .min(1)
        .max(MAX_PAGE_SIZE)
        .default(DEFAULT_PAGE_SIZE),
});
/** Envelope de uma página de `item`. */
export const pageOf = (item) => z.strictObject({
    items: z.array(item),
    page: z.int().min(1),
    pageSize: z.int().min(1).max(MAX_PAGE_SIZE),
    totalItems: z.int().nonnegative(),
    totalPages: z.int().nonnegative(),
});
//# sourceMappingURL=pagination.contract.js.map